
import ModalDeleteTeam from "../../app/users/teams/components/modal-delete-team";
import ProjectSession from "../model2/project/project-session";


export default class TeamsModalsManager {

    constructor() {}

    deleteTeam(projects: ProjectSession[], teamId: ID) {

        gd.modal.showV4({
            className: 'modal-delete-team',
            component: ModalDeleteTeam,
            params: {
                projects: projects,
                teamId: teamId
            }
        })
    }
}
